<template>
  <div>
    <v-row
      v-if="ProgessStart == 1"
      wrap
    >
      <v-col
        align="center"
        cols="12"
        md="12"
      >
        <v-progress-circular
          :rotate="180"
          :size="100"
          :width="15"
          :value="UploadPercentage"
          color="#00a4ef"
        >
          {{ UploadPercentage }}
        </v-progress-circular>
        <h3 class="red--text">
          Please wait, we are uploading your details. Time may vary based on
          your internet connection.
        </h3>
      </v-col>
      <br>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "UploadProgress",
  props: {
    ProgessStart: {
      required: true,
    },
    UploadPercentage: {
      required: true,
    },
  },
  computed: {},
  mounted() {},
};
</script>

<style lang="scss">
</style>
